export const toSnakeCase = (str: string): string => {
  return str.toLowerCase().replaceAll(' ', '_');
}
